// Web: no-op. Chromecast is provided by the Moviie embed player (the web
// rendition of <MoviieVideo> is the embed iframe), not by the native adapter.
export {}
